import useRolePermission from "entities/auth/hooks/useRolePermission";
import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { useThemeTagDetails } from "../../context";
import { TagDetailsTabs } from "../../context/types";
import { StyledTab, StyledTabs } from "./styled";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useThemeTagDetails();
  const { allowed: hasReadAccess } = useRolePermission("themeTags:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission(
    "themeTags:translations:read",
  );

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab =
    hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: TagDetailsTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="tag-tab-general"
          aria-controls="tag-tabpanel-general"
          value={TagDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="tag-tab-translations"
          aria-controls="tag-tabpanel-translations"
          value={TagDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
